<template>
    <div>
        <v-dialog v-model="showDialog" persistent max-width="60%">
            <v-stepper v-model="e1" >
                <v-stepper-header>
                    <v-stepper-step :complete="e1 > 1" step="1">Nhập thông tin cá nhân</v-stepper-step>
            
                    <v-divider></v-divider>
            
                    <v-stepper-step :complete="e1 > 2" step="2">Nhập địa chỉ</v-stepper-step>
                </v-stepper-header>
            
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-container align="center">
                            <v-row no-gutters>
                                <v-col cols="12" sm="6" class="pr-2">
                                <v-text-field v-model="customer.fullname" :rules="stringRules" v-bind:label="$t('profile.fullname')" outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" class="pl-2">
                                <v-text-field v-model="customer.email" :rules="emailRules" v-bind:label="$t('profile.email')" outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" class="pr-2">
                                <v-text-field v-model="customer.phone" :rules="phoneRules" v-bind:label="$t('profile.phone')" outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" class="pl-2">
                                <v-text-field v-model="customer.facebook" v-bind:label="$t('profile.facebook')" outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" class="pr-2">
                                <!-- <v-text-field v-model="date" :rules="stringRules" type="date" v-bind:label="$t('profile.birthday')" outlined ></v-text-field> -->
                                <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                                    <template v-slot:activator="{ on }">
                                    <v-text-field v-model="computedDateFormatted" v-bind:label="$t('profile.birthday')" readonly v-on="on" outlined dense></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date" scrollable locale="vi">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="modal = false"> {{ $t('common.cancel') }} </v-btn>
                                    <v-btn text color="primary" @click="$refs.dialog.save(date)"> {{ $t('common.ok') }} </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                                
                                </v-col>
                            </v-row>
                            
                        </v-container>

                        <v-divider></v-divider>
                        <v-toolbar flat>
                            <v-btn color="primary" width="120px" @click="cancel">{{ $t('common.cancel') }}</v-btn>

                            <v-spacer> </v-spacer>

                            <v-btn color="primary" @click="createUser" class="mr-5">
                            {{ $t('common.continue') }}
                            </v-btn>                       
                        </v-toolbar>
                    </v-stepper-content>
            
                    <v-stepper-content step="2">
                        <v-container align="center">
                            <v-row align="start" justify="start">
                                <v-col v-for="detail in addresses" :key="detail._id" :cols="6">
                                    <v-card>
                                        <v-card-title v-text="detail.name">
                                            
                                        </v-card-title>
                                        
                                        <v-card-text>
                                            {{ addressToString(detail) }}
                                            <br/>
                                            {{ detail.phone }}
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-checkbox v-model="selectedAddressDefault" v-bind:label="$t('create_design_request.default_address')" color="success" 
                                                :value="detail"
                                                hide-details @click="setDefaultAddress(detail)">
                                            </v-checkbox>

                                            <v-spacer></v-spacer>

                                            <v-btn icon>
                                                <v-icon @click="editAddress(detail)">edit</v-icon>
                                            </v-btn>

                                            <v-btn icon>
                                                <v-icon @click="deleteAddress(detail)">mdi-delete</v-icon>
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                                

                                <v-col cols="10">
                                    <v-btn color="primary" width="200px" @click="addMoreAddress"> {{ $t('common.add') }} </v-btn>
                                </v-col>

                            </v-row>
                        </v-container>

                        <v-divider></v-divider>
                        <v-toolbar flat>
                            <v-btn color="primary" width="120px" @click="back">{{ $t('common.back') }}</v-btn> 

                            <v-spacer> </v-spacer>

                            <v-btn color="primary" width="120px" @click="closeDialog">{{ $t('common.done') }}</v-btn>                    
                        </v-toolbar>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>

        </v-dialog>

        <v-dialog v-model="dialogAddAddress" persistent max-width="70%">
            <v-card>
                <v-card-title>
                    <span class="headline"> {{ $t('tooltip_infor.address_title') }} </span>
                </v-card-title>

                <v-card-text>
                    <v-container align="center">
                        <v-row no-gutters>
                            <v-col cols="12" sm="6" class="pr-2">
                                <v-text-field v-model="nameReceive" :rules="stringRules" v-bind:label="$t('profile.fullname')" outlined dense>
                                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                                        <template v-slot:activator="{ on }">
                                            <v-icon color="primary" dark v-on="on">info</v-icon>
                                        </template>
                                        <span>{{ $t('tooltip_infor.name_receive') }}</span>
                                    </v-tooltip>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" class="pl-2">
                                <v-autocomplete v-model="selectProvince" :items="provinces" item-text="province_name" v-bind:label="$t('profile.province')" outlined return-object dense>
                                        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                                            <template v-slot:activator="{ on }">
                                                <v-icon color="primary" dark v-on="on">info</v-icon>
                                            </template>
                                            <span>{{ $t('tooltip_infor.select_province') }}</span>
                                        </v-tooltip>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" class="pr-2">
                                <v-text-field v-model="phoneReceive" :rules="phoneRules" v-bind:label="$t('profile.phone')" outlined dense>
                                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                                        <template v-slot:activator="{ on }">
                                            <v-icon color="primary" dark v-on="on">info</v-icon>
                                        </template>
                                        <span>{{ $t('tooltip_infor.phone_receive') }}</span>
                                    </v-tooltip>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" class="pl-2">
                                <v-autocomplete v-model="selectDistrict" :items="districts" item-text="district_name" v-bind:label="$t('profile.district')" outlined return-object dense>
                                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                                        <template v-slot:activator="{ on }">
                                            <v-icon color="primary" dark v-on="on">info</v-icon>
                                        </template>
                                        <span>{{ $t('tooltip_infor.select_district') }}</span>
                                    </v-tooltip>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" class="pr-2">
                                <v-autocomplete v-model="selectPhoneType" :items="phoneTypes" item-text="name" v-bind:label="$t('profile.phone_type')" outlined return-object dense>
                                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                                        <template v-slot:activator="{ on }">
                                            <v-icon color="primary" dark v-on="on">info</v-icon>
                                        </template>
                                        <span>{{ $t('tooltip_infor.phone_type') }}</span>
                                    </v-tooltip>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" class="pl-2">
                                <v-autocomplete v-model="selectWard" :items="wards" v-bind:label="$t('profile.ward')" item-text="wards_name" outlined return-object dense>
                                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                                        <template v-slot:activator="{ on }">
                                            <v-icon color="primary" dark v-on="on">info</v-icon>
                                        </template>
                                        <span>{{ $t('tooltip_infor.select_ward') }}</span>
                                    </v-tooltip>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field v-model="detail" v-bind:label="$t('profile.address')" outlined dense>
                                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                                        <template v-slot:activator="{ on }">
                                            <v-icon color="primary" dark v-on="on">info</v-icon>
                                        </template>
                                        <span>{{ $t('tooltip_infor.address_detail') }}</span>
                                    </v-tooltip>
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-divider></v-divider>

                        <v-toolbar flat>
                            <v-btn color="primary" @click="closeAddAddress" width="200px">{{ $t('common.cancel') }} </v-btn>
                            <v-spacer> </v-spacer>
                            <v-btn color="primary" @click="addAddress" width="200px" class="mr-5">{{ $t('common.save') }} </v-btn>                      
                        </v-toolbar>
                    </v-container>
                </v-card-text>
            </v-card>
           
        </v-dialog>

    </div>
</template>

<script>
    import i18n from '@/plugins/i18n';
    import moment from 'moment';

    export default {
        name: 'customer-dialog',

        data: ()=> ({
            e1: 1,
            date: '',
            modal: false,

            customer: {},
            dialogAddAddress: false,
            editedAddressIndex: -1,
            selectedAddressDefault: {},
            addresses: [],
            editedAddress: {},

            dialog: false,


            selectDistrict: null,
            selectProvince: null,
            selectWard: null,
            detail: '',
            nameReceive: '',
            phoneReceive: '',
            provinces: [],
            districts: [],
            wards: [],
            firstEdit: true,

            phoneTypes: [
                {name: "Học sinh", type: 1},
                {name: "Phụ huynh", type: 2},
                {name: "Giáo viên", type: 3},
                {name: "Khác", type: 4},
            ],

            selectPhoneType: {},

            stringRules: [
                v => !!v || i18n.t('validate.not_empty'),
                // v => (v && v.length > 5) || i18n.t('validate.string_invalid')
            ],
            phoneRules: [
                v => !!v || i18n.t('validate.not_empty'),
                v => (v && v.length > 9) || i18n.t('validate.phone_invalid'),
            ],
            addressRules: [
                v => !!v || i18n.t('validate.not_empty'),
                v => (v && v.length > 3) || i18n.t('validate.address_invalid'),
            ],
            emailRules: [
                // v => !!v || i18n.t('validate.email_require'),
                v => /.+@.+\..+/.test(v) || i18n.t('validate.email_invalid'),
            ],
            passdRules: [
                v => !!v || i18n.t('validate.password_require'),
                v => (v && v.length > 5) || i18n.t('validate.password_invalid'),
            ],
        }),

        computed: {
            computedDateFormatted () {
                return this.formatDate(this.date)
            },
        },

        props: {
        // Use "value" to enable using v-model
            showDialog: Boolean,
            editedItem: Object,
            editedIndex: Number
        },

        watch: {
            selectProvince (val) {
                if (!this.firstEdit) {
                    this.selectWard = null;
                }

                if (val && val.province_id) {
                    this.getDistrictByProvinceID(val.province_id);
                } 
            },

            selectDistrict (val) {
                if (val && val.district_id) {
                    this.getWardByDistrictID(val.district_id);
                }
            },

            dialogAddAddress (val) {
                val || this.closeAddAddress()
            },
        },

        mounted() {
            
        },

        async created () {
            this.getProvince(),
            this.selectPhoneType = this.phoneTypes[0];

            this.dialog = this.value;
            this.customer = this.editedItem;
            this.date = this.customer.birthday ? moment(String(this.customer.birthday)).format("YYYY-MM-DD") : '';
            this.addresses = this.customer.addresses ? this.customer.addresses : [];
            this.selectedAddressDefault = this.customer.defaultAddress;
        },

        methods: {
            formatDate (date) {
                if (!date) {
                    return null;
                }

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },

            async createUser() {
                if (!this.customer.fullname || this.customer.fullname.trim().length == 0) {
                    alert(i18n.t('validate.name_customer_empty'));
                    return;
                }

                if (!this.customer || 
                    ((!this.customer.phone || this.customer.phone.trim().length === 0) && 
                    (!this.customer.facebook || this.customer.facebook.trim().length === 0))) {
                    alert(i18n.t('validate.phone_fb_empty'));
                    return;
                }

                if (!this.date) {
                    alert(i18n.t('validate.birthday_empty'));
                    return;
                }

                if (this.editedIndex > -1) {
                    const self = this;
                    const requestBody = {};
                    Object.assign(requestBody, self.customer);
                    requestBody.birthday = moment(String(this.date)).format("DD/MM/YYYY");
                    self.customer.birthday = this.date;
                    try {
                        const response =  await this.$http.put(process.env.VUE_APP_CUSTOMER_API + self.customer._id, requestBody);
                        if (response.data && response.data.success) {
                            this.e1 = 2;
                        } else if(response.data && !response.data.success) {
                            alert(i18n.t(response.data.message));
                        } else {
                            alert(i18n.t('validate.request_error'));
                        }
                    } catch(e) {
                        console.log(e.stack);
                        alert(i18n.t('validate.request_error'));
                    }
                } else {
                    const self = this;
                    const requestBody = {};
                    Object.assign(requestBody, self.customer);
                    requestBody.birthday = moment(String(this.date)).format("DD/MM/YYYY");
                    self.customer.birthday = this.date;
                    try {
                        const response =  await this.$http.post(process.env.VUE_APP_CUSTOMER_API, requestBody);
                        if (response.data && response.data.success) {
                            self.customer._id = response.data.data.id;
                            this.e1 = 2;
                        } else if(response.data && !response.data.success) {
                            alert(i18n.t(response.data.message));
                        } else {
                            alert(i18n.t('validate.request_error'));
                        }
                    } catch(e) {
                        alert(i18n.t('validate.request_error'));
                    }
                }
            },

            addMoreAddress() {
                this.nameReceive = this.customer.fullname;
                this.phoneReceive = this.customer.phone;
                this.editedAddressIndex = -1;
                this.dialogAddAddress = true;
            },

            async editAddress(detail) {
                this.firstEdit = true;
                this.editedAddressIndex = this.addresses.indexOf(detail);
                this.editedAddress = Object.assign({}, detail);
                this.nameReceive = this.editedAddress.name;
                this.detail = this.editedAddress.detail;
                this.phoneReceive = this.editedAddress.phone;
                this.selectPhoneType = this.phoneTypes.find(item => item.type == this.editedAddress.phoneType);

                this.getFullInfoByWardId(detail.ward)
                this.dialogAddAddress = true;
            },

            closeAddAddress() {
                this.dialogAddAddress = false;
            },



            async getProvince() {
                try {
                    // const response =  await this.$http.get('/province');
                    const response =  await this.$http.get(process.env.VUE_APP_VT_PROVINCE_API);
                    if (response.data && response.data.success) {
                        this.provinces = response.data.data;
                        // this.selectProvince = this.provinces[0];
                    }
                } catch(e) {
                    console.log(e.stack);
                }
            },

            async getDistrictByProvinceID(provinceId) {
                try {
                    // const response =  await this.$http.get('/province/province/' + provinceId);
                    const response =  await this.$http.get(process.env.VUE_APP_VT_DISTRICT_API + provinceId);
                    if (response.data && response.data.success) {
                        this.districts = response.data.data;
                    }
                } catch(e) {
                    console.log(e.stack);
                }
            },
            
            back () {
                if (this.e1 > 1) {
                    this.e1 = this.e1 - 1;
                }
            },


            async getWardByDistrictID(districtId) {
                try {
                    // const response =  await this.$http.get('/province/province/' + provinceId);
                    const response =  await this.$http.get(process.env.VUE_APP_VT_WARD_API + districtId);
                    if (response.data && response.data.success) {
                        this.wards = response.data.data;
                    }
                } catch(e) {
                    console.log(e.stack);
                }
            },

            async getFullInfoByWardId(wardId) {
                if (!wardId) {
                    return;
                }

                try {
                    // const response =  await this.$http.get('/province/province/' + provinceId);
                    const response =  await this.$http.get(process.env.VUE_APP_VT_FULL_INFO_API + wardId);
                    if (response.data && response.data.success) {
                        this.selectProvince = response.data.data.province;
                        this.selectDistrict = response.data.data.district;
                        this.selectWard = response.data.data.ward;

                        setTimeout(() => {this.firstEdit = false}, 1000);
                    }
                } catch(e) {
                    console.log(e.stack);
                }
            },

            addressToString(detail) {
                if (detail && detail.fullDetail) {
                    return detail.fullDetail;
                } else {
                    return '';
                }
            },

            async setDefaultAddress(address) {
                const requestBody = {
                    defaultAddress: address._id
                }
                try {
                    const response =  await this.$http.put(process.env.VUE_APP_CUSTOMER_API + this.customer._id + "/defaultAddress", requestBody);

                    if (response.data && response.data.success) {
                        this.selectedAddressDefault = address;
                        this.customer.defaultAddress = this.selectedAddressDefault;
                    }
                } catch(e) {
                    console.log(e.stack);
                }
            },

            async deleteAddress(detail) {
                const agree = confirm(i18n.t('common.confirm_delete'))
                if (agree) {
                    const response =  await this.$http.delete(process.env.VUE_APP_ADDRESS_API + detail._id);
                    if(response.data && response.data.success) {
                        const index = this.addresses.indexOf(detail);
                        this.addresses.splice(index, 1);
                    } else if(response.data && !response.data.success) {
                        alert(i18n.t(response.data.message));
                    } else {
                        alert(i18n.t('validate.request_error'));
                    }
                }
            },

            async addAddress() {  
                if (!this.nameReceive || this.nameReceive.length == 0) {
                    alert(i18n.t('validate.name_customer_empty'));
                    return;
                }

                if (!this.phoneReceive || this.phoneReceive.length == 0) {
                    alert(i18n.t('validate.phone_customer_empty'));
                    return;
                }

                if (!this.selectWard) {
                    alert(i18n.t('validate.ward_empty'));
                    return;
                }

                if (!this.detail) {
                    alert(i18n.t('validate.address_invalid'));
                    return;
                }

                const self = this;
                const fullDetail = (self.detail ? self.detail + ", " : "") + self.selectWard.wards_name + ", " + self.selectDistrict.district_name 
                                    + ", " + self.selectProvince.province_name

                if (this.editedAddressIndex > -1) {
                    const requestBody = {
                        name : self.nameReceive,
                        cid : self.customer._id,
                        phone: self.phoneReceive,
                        phoneType: self.selectPhoneType.type,
                        detail : self.detail,
                        ward : self.selectWard.wards_id,
                        fullDetail: fullDetail
                    };

                    try {
                        const response =  await self.$http.put(process.env.VUE_APP_ADDRESS_API + self.editedAddress._id, requestBody);
                        if (response.data && response.data.success) {
                            self.editedAddress.fullDetail = fullDetail;
                            self.editedAddress.ward = self.selectWard.wards_id;
                            self.editedAddress.detail = self.address;
                            self.editedAddress.phone = self.phoneReceive;
                            self.editedAddress.phoneType = self.selectPhoneType.type;
                            Object.assign(self.addresses[self.editedAddressIndex], self.editedAddress);
                            self.editedAddress = {};
                            self.editedAddressIndex = -1;

                            self.$fire({
                                title: i18n.t('common.update_success'),
                                text: "",
                                type: "success"
                            }).then(() => {
                                self.selectedAddressDefault = requestBody;
                                Object.assign(self.selectedAddressDefault, requestBody);
                                if (self.addresses.length > 0) {
                                    self.setDefaultAddress(self.selectedAddressDefault);
                                }
                                
                                self.closeAddAddress();
                            });
                        } else if(response.data && !response.data.success) {
                            alert(i18n.t(response.data.message));
                        } else {
                            alert(i18n.t('validate.request_error'));
                        }
                    } catch(e) {
                        console.log(e.stack);
                        alert(i18n.t('validate.request_error'));
                    }
                } else {
                    const requestBody = {
                        name : self.nameReceive,
                        cid : self.customer._id,
                        phone: self.phoneReceive,
                        phoneType: self.selectPhoneType.type,
                        detail : self.detail,
                        ward : self.selectWard.wards_id,
                        fullDetail: fullDetail
                    };

                    try {
                        const response =  await this.$http.post(process.env.VUE_APP_ADDRESS_API, requestBody);
                        if (response.data && response.data.success) {
                            requestBody._id = response.data.data.id;
                            self.addresses.push(requestBody);
                            
                            this.$fire({
                            title: i18n.t('common.update_success'),
                            text: "",
                            type: "success"
                            }).then(() => {
                                self.nameReceive = '';
                                self.detail = '';

                                self.selectedAddressDefault = requestBody;
                                Object.assign(self.selectedAddressDefault, requestBody);
                                if (self.addresses.length > 0) {
                                    this.setDefaultAddress(self.selectedAddressDefault);
                                }
                                
                                self.closeAddAddress();
                            });
                        } else if(response.data && !response.data.success) {
                            alert(i18n.t(response.data.message));
                        } else {
                            alert(i18n.t('validate.request_error'));
                        }
                    } catch(e) {
                        console.log(e.stack);
                        alert(i18n.t('validate.request_error'));
                    }
                }
            },

            cancel() {
                // this.showDialog = false;
                self.e1 = 1;
                this.$emit('closeDialog', false);
            },

            closeDialog() {
                const self = this;
                self.e1 = 1;
                // this.showDialog = false;
                this.$emit('closeDialog', false);
                this.$emit('updateCustomer', self.customer);
            }

        }
    }
</script>
<style scoped>

  .v-text-field .v-input__control .v-input__slot {
    min-height: 45px !important;
    /* display: flex !important; */
    align-items: center !important;
  }
</style>